<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header">
      {{changeStateModal.modalTitle}}
    </span>
  </div>
  @if (changeStateModal.loaded) {
    <states-process
      [type]="'processConcept'"
      [typeView]="'changeStateModal'"
      [concept]="changeStateModal.evaluateConcept"
      [item]="changeStateModal.evaluateConcept"
      [userPublic]="changeStateModal.userPublic"
      (changeStateModal)="handleAccept($event)">
    </states-process>
  }
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'"
        >_Cerrar</span>
    </button>
  </div>

<!--
<div class="change-state-modal">
  <div class="common__modal-header-block">
    <i class="lf-icon-process common__icon-header"></i>
    <span class="common__text-header"
      [afTranslate]="'dashboard-reports.resolucion'">
    </span>
    <i class="lf-icon-close common__icon-close-modal"
    (click)="handleDismiss()"></i>
  </div>
  <div class="change-state-modal__body-container">

  </div>
</div> -->
